/**
 * Rounds a number to a specified number of decimal places.
 *
 * @param {number} value - The number to round.
 * @param {number} [precision=0] - The number of digits after the decimal point. Defaults to 0.
 * @returns {number} The rounded number.
 */
export function round(value: number, precision: number = 0) {
  if (isNaN(value)) {
    return NaN;
  }
  const multiplier = Math.pow(10, precision);
  return Math.round(value * multiplier) / multiplier;
}

/**
 * Checks if a custom value is within a specified tolerance of a default value.
 *
 * @param {number} defaultValue - The reference value to compare against.
 * @param {number} customValue - The value to check.
 * @param {number} [tolerance=0.001] - Optional. Maximum allowed difference from the default value.
 * @param {number} [precision=6] - Optional. Number of decimals to round for safe comparison.
 * @returns {boolean} Returns true if the custom value is within the tolerance range of the default value.
 */
export function isWithinRange(defaultValue: number, customValue: number, tolerance = 0.001, precision = 6) {
  const diff = Math.abs(customValue - defaultValue);
  const roundedDiff = Number(diff.toFixed(precision));
  return roundedDiff <= tolerance;
}
